import type {
  EmailVerifierValues,
  SignInValues,
} from '@/models/interfaces/auth/AuthenticationsValues'
import type { User } from '@/models/interfaces/auth/User'
import { apiClient } from '@/plugins/axios/api'
import type { AxiosResponse } from 'axios'

export class AuthenticationService {
  static async signIn(values: SignInValues): Promise<AxiosResponse> {
    return apiClient.post('/auth', JSON.stringify(values))
  }

  static async getAuthenticatedUser(): Promise<AxiosResponse<User>> {
    return apiClient.get('/api/utilisateurs/me')
  }

  static async forgotPassword(email: string): Promise<AxiosResponse> {
    return apiClient.post('/api/forgot_password/', { email: email })
  }

  static async checkResetPasswordToken(token: string): Promise<AxiosResponse> {
    return apiClient.get(`/api/forgot_password/${token}`)
  }

  static async resetPassword(token: string, plainPassword: string) {
    const url = `/api/forgot_password/${token}`
    const payload = {
      userLogin: plainPassword,
    }
    return apiClient.post(url, payload)
  }

  static async verifyEmail(emailVerifierValues: EmailVerifierValues): Promise<AxiosResponse> {
    return apiClient.post('/api/utilisateurs/verify_email/verify', emailVerifierValues)
  }

  static async resendEmailVerifier(email: string): Promise<AxiosResponse> {
    return apiClient.post(`/api/utilisateurs/verify_email/send`, { email: email })
  }

  static async refreshAuthToken(): Promise<AxiosResponse> {
    return apiClient.post('/api/token/refresh', {}, { withCredentials: true })
  }
}
